import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { Separador } from "app/components/separador/Separador";
import { useAppSelector } from "app/redux/hooks";
import { Parametro } from "app/types/Parametro";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react"
import { ProdutoLoteEditarContainer } from "../produto-lote-editar/ProdutoLoteEditarContainer";
import { DadosProdutosLote, Lotes, ProdutoLote } from "./ProdutoLote"
import store from "app/redux/store/store";
import { atualizarItemAction } from "app/redux/orcamentoSlice";
import * as totalizadorActions from 'app/redux/totalizadorSlice'
import { atualizarOrcamento } from "app/use-cases/orcamento/atualizarOrcamento";

export type ProdutoLoteContainerProps = {
    identificadorItem: number
    passos: Dict<string, () => void>,
    onVoltar: () => void,
}

declare const window: any

export const ProdutoLoteContainer = (props: ProdutoLoteContainerProps) => {

    const orcamento = useAppSelector((store) => store.orcamento);
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    const [dadosProdutosLote, setDadosProdutosLote] = useState<DadosProdutosLote>({})
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [parametrosCarregados, setParametrosCarregados] = useState(false)

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
                nomes: [
                    "CONTROLE_VALIDADE_PRODUTOS",
                    "CHAVE_MOVIMENTACAO_ORCAMENTO"
                ],
            })
        );
    };

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    const onObterDadosLote = async () => {
        try {
            globalMU.blockUI()
            const resposta = await microuniversoApi.Orcamento.lotesProduto(orcamento.IdentificadorOrcamento, props.identificadorItem)
            if (("Error" in resposta)) {
                onVoltar();
                return
            }
            setDadosProdutosLote(resposta)
            atualizarOrcamento()

            store.dispatch(atualizarItemAction({ identificador: props.identificadorItem, dados: { ...resposta.ItensOrcamento[0], OidOferta: resposta.ItensOrcamento[0].OidOferta } }))
            window.orcamentoController.model.atualizar(resposta.ItensOrcamento)
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        passosInterno.current.get(passo)()
    }

    const onFuncaoRetornaPagina = () => {
        renderizarComponentReact(<ProdutoLoteContainer {...props} />, "conteudo-pagina", true)
    }

    const onEditarProdutoLote = (dadosLotes: Lotes) => {
        if (dadosLotes && !dadosLotes.PermiteVendaLote) {
            globalMU.showErrorMessage("Lote não pode ser utilizado.");
            return;
        }

        renderizarComponentReact(
            <ProdutoLoteEditarContainer
                dadosProdutoLote={dadosProdutosLote}
                lote={{ ...dadosLotes, CodigoObjetoItemOrcamento: dadosProdutosLote.CodigoObjetoItemOrcamento }}
                onVoltar={onFuncaoRetornaPagina} passos={passosInterno.current}
            />, "conteudo-pagina", true
        )
    }


    useEffect(() => {
        atualizarParametros()
        onObterDadosLote()
        passosInterno.current.set(valorParametro("CONTROLE_VALIDADE_PRODUTOS") == "S" ?
            "Lotes/Validade do Produto" : "Lotes do Produto", onFuncaoRetornaPagina)
        setParametrosCarregados(true)
    }, [])

    return (
        <>
            {parametrosCarregados &&
                <>
                    <Breadcrumb2Container
                        passos={passosInterno.current.keysToList()}
                        id="ProdutoLoteContainer"
                        exibirBotaoLimpar={false}
                        exibirBotaoVoltar={true}
                        onBotaoVoltarClicado={onVoltar}
                        onPassoSelecionado={onPassoSelecionado}
                    />

                    <br />

                    <ProdutoLote
                        dados={dadosProdutosLote}
                        controlaValidade={valorParametro("CONTROLE_VALIDADE_PRODUTOS") == "S"}
                        mostrarNomeComoCodigo={valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C"}
                        onEditar={onEditarProdutoLote}
                    />
                </>
            }
        </>
    )
}